import { defineAsyncComponent } from 'vue';

// Router
import addRoutes from '@martyrs/src/modules/core/views/router/addRoutes.js';
import { getRoutes } from './router/backoffice.router.js';

// Локали модуля: язык грузит module.manager при активации, только текущий.
export const locales = {
  en: () => import('./views/locales/en.js'),
  ru: () => import('./views/locales/ru.js'),
};

// Views
// Pages
export const Dashboard = defineAsyncComponent(() => import('./components/pages/Dashboard.vue'));

// Маршруты модуля объявляются на старте приложения (moduleManager.registerAll)
export function register(app, store, router, options = {}) {
  const routes = getRoutes(options);
  routes.forEach(({ parentName, config }) => {
    addRoutes(router, { ...config, parentName });
  });
}

const ModuleBackoffice = {
  register,
  views: {
    router: {
      getRoutes,
    },
    components: {
      Dashboard,
    },
  },
};

export default ModuleBackoffice;
